import { Component, Input, ViewEncapsulation } from '@angular/core';
import { Signatur } from '../interfaces/signatur.interface';

@Component({
  selector: 'signature-icon',
  template: `
  <span *ngIf="signature" class="badge badge-pill badge-warning" title="Signerad av {{ signature.fornamn }} {{ signature.efternamn }} ({{ signature.tidpunkt | localizeddate:'shortDate' }} {{ signature.tidpunkt | localizeddate:'shortTime' }})">
    <fa-icon [icon]="['fas', signature ? 'award' : 'pen-nib']" [size]="size || 'lg'" class="mr-1"></fa-icon><span class="initials">{{ initials | uppercase }}</span>
  </span>
  <span *ngIf="!signature" class="text-muted" title="Ej signerad">Ej signerad</span>`
})
export class SignatureIconComponent {
  @Input() public signature: Signatur;
  @Input() public size: string;

  public get initials(): string {
    let result = '';

    if (!this.signature)
      return result;

    if (this.signature.fornamn)
      result += this.signature.fornamn.slice(0, 1);

    if (this.signature.efternamn)
      result += this.signature.efternamn.slice(0, 1);

    return result;
  };
}
